import { withMotion } from '@hoc/withMotion';
import { ReactComponent as SvgArrowRight } from '@img/icons/arrow-right.svg';
import { ReactComponent as SvgHeaderLogo } from '@img/logos/header-logo.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import Navigation from '@stories/Components/Navigation/Navigation';
import NavigationMobile from '@stories/Components/NavigationMobile/NavigationMobile';
import { Divide as Hamburger } from 'hamburger-react';
import * as React from 'react';
import S from './Header.styles';
const Header = ({ cta, navigation }) => {
    const [isMobileNavActive, setIsMobileNavActive] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { background: !isMobileNavActive, themeOption: isMobileNavActive ? 'light' : 'dark' },
            React.createElement(S.Inner, null,
                React.createElement(S.LogoLink, { href: "/" },
                    React.createElement(S.Logo, { as: SvgHeaderLogo, "aria-label": "Real Estate Management (UK) Limited" })),
                React.createElement(Navigation, { items: navigation }),
                cta?.text && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { href: cta.url, icon: SvgArrowRight, target: cta.target, themeOption: "white", title: cta.text, "aria-label": cta.accessibleText }))),
                React.createElement(Hamburger, { label: isMobileNavActive ? 'Close Navigation' : 'Open Navigation', toggled: isMobileNavActive, toggle: setIsMobileNavActive }))),
        React.createElement(NavigationMobile, { cta: cta, items: navigation, themeOption: "light", visible: isMobileNavActive })));
};
export default withMotion(Header);
